import { ActionCreatorWithoutPayload, createAction} from "@reduxjs/toolkit";

export namespace MainProductLimitAction {

  export const productLimit: ActionCreatorWithoutPayload = createAction('GET_PRODUCTS_LIMIT');
}
